export interface IPage {
  id: number;
  name: string;
  content: string;
}

export interface IPagesStore {
  [clubId: number]: IPage[];
}

export const pagesStore: IPagesStore = {};
